import React from 'react';
import Rating from 'react-rating';
import './CourseContainer.css'
import toc from '../files/TOC.pdf'
import { Link } from 'react-router-dom';
const CourseContainer = (props) => {
    const { name,rating, ins_name, img } = props.clas;
    return (
        <div className='col-md-6 course-detail'>
            <div className='single-course d-flex flex-wrap' >
                <div>
                    <img src={img} alt="" className='img-fluid course-img' />
                </div>
                <div className='mx-4'>
                    <h4>{name}</h4>
                    <p>Solved By:{ins_name}</p>
                    {/* <a href="/static/media/resume.e7802759.pdf" download="resume.pdf"> <button type="button" class="btn btn-outline-dark">Download Resume</button></a> */}
                    <a href={rating} target="_blank" download="TOC.pdf"> <button type="button" class="btn btn-outline-dark">Download Now</button></a>
                </div>
            </div>
        </div>
        
    );
};

export default CourseContainer;